<template>
	<div
		ref="bait"
		class="jw-ad ad-banner pub_300x250 pub_300x250m pub_728x90 text-ad textAd text_ad text_ads text-ads text-ad-links"
		style="height: 1px; width: 1px; position: absolute"
	>
		<img
			src="https://pagead2.googlesyndication.com/pagead/imgad?id=CICAgKDnqzjtABABGAEyCK1i2aHnQwMB"
			width="1"
			height="1"
			style="display: none"
			@error="() => (blocked = true)"
			@load="() => (blocked = false)"
		/>
	</div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from 'vue';
import { SnowplowLoginContext, SnowplowTitleContextGraphql } from '@/helpers/tracking/providers/snowplow-contexts';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { storeToRefs } from 'pinia';
import { useTitleDetailsStore } from '@/stores/pinia/useTitleDetailsStore';
import { useAppStore } from '@/stores/pinia/useAppStore';
import { useTrackingStore } from '@/stores/pinia/useTrackingStore';

const { jwLoginId } = storeToRefs(useUserStore());
const { titleContext } = storeToRefs(useTitleDetailsStore());
const { setSessionEnvironmentByKey } = useTrackingStore();
const { setIsUsingAdBlocker } = useAppStore();

const bait = ref<HTMLElement | null>(null);

const blocked = ref(false);
const lastTrackedValue = ref<boolean | null>(null);

async function handleAdblockerTracking() {
	if (!blocked.value) {
		await new Promise(resolve => setTimeout(resolve, 100));
	}

	// already tracked an adblocker
	if (lastTrackedValue.value) return;

	const contexts = [];
	if (titleContext.value) {
		const { titleId, objectType, seasonNumber, episodeNumber, contentType } = titleContext.value;
		contexts.push(new SnowplowTitleContextGraphql(titleId, objectType, seasonNumber, episodeNumber, contentType));
	}

	if (jwLoginId.value) contexts.push(new SnowplowLoginContext(jwLoginId.value));

	setIsUsingAdBlocker(!!blocked.value);

	TrackingHelper.trackEvent(
		'adblocker',
		{
			action: 'detected',
			value: blocked.value ? 1 : 0,
			nonInteraction: true,
		},
		contexts
	);
	setSessionEnvironmentByKey({ key: 'hasAdBlocker', value: blocked.value });
	// hasAdBlocker is the last sessionEnvironment key to be set, so we can now set sessionReady to true
	setSessionEnvironmentByKey({ key: 'sessionReady', value: true });

	lastTrackedValue.value = blocked.value;
}

//Track blocked status changes, since @error() might take time to fire
watch(blocked, blockedUpdate => {
	if (blockedUpdate === true && !lastTrackedValue.value) handleAdblockerTracking();
});

onMounted(() => {
	blocked.value = blocked.value || bait.value === null || window.getComputedStyle(bait.value).display === 'none';
	handleAdblockerTracking();
});
</script>
